import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const EmailQuote = {
  Header: lazy(
    () =>
      import('components/direct-sales/email-quote/components/EmailQuoteHeader')
  ),
  Content: lazy(
    () =>
      import('components/direct-sales/email-quote/components/EmailQuoteContent')
  )
};

export default EmailQuote;
